/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BurnPresale, BurnPresaleInterface } from "../BurnPresale";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IToken",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_aggregatorAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_burnOracleAddr",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_limit",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "_rate",
        type: "uint64",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Buy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Claim",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "txHash",
        type: "bytes32",
      },
    ],
    name: "ProcessTx",
    type: "event",
  },
  {
    inputs: [],
    name: "aggregator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "aggregatorClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "availableToClaim",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "availableTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "txHash",
        type: "bytes32",
      },
    ],
    name: "buyWithBurnOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "fund",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "processedTxes",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "saleData",
    outputs: [
      {
        components: [
          {
            internalType: "uint64",
            name: "locked",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "rate",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "limit",
            type: "uint64",
          },
          {
            internalType: "enum Status",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "unlockedPercent",
            type: "uint8",
          },
        ],
        internalType: "struct PresaleData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "_limit",
        type: "uint64",
      },
    ],
    name: "setLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "_rate",
        type: "uint64",
      },
    ],
    name: "setRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum Status",
        name: "_status",
        type: "uint8",
      },
    ],
    name: "setStatus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_unlocked",
        type: "uint8",
      },
    ],
    name: "setUnlockedPercent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transferToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userData",
    outputs: [
      {
        internalType: "uint64",
        name: "balance",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "maxBalance",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BurnPresale__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _token: string,
    _aggregatorAddr: string,
    _burnOracleAddr: string,
    _limit: BigNumberish,
    _rate: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BurnPresale> {
    return super.deploy(
      _token,
      _aggregatorAddr,
      _burnOracleAddr,
      _limit,
      _rate,
      overrides || {}
    ) as Promise<BurnPresale>;
  }
  getDeployTransaction(
    _token: string,
    _aggregatorAddr: string,
    _burnOracleAddr: string,
    _limit: BigNumberish,
    _rate: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _token,
      _aggregatorAddr,
      _burnOracleAddr,
      _limit,
      _rate,
      overrides || {}
    );
  }
  attach(address: string): BurnPresale {
    return super.attach(address) as BurnPresale;
  }
  connect(signer: Signer): BurnPresale__factory {
    return super.connect(signer) as BurnPresale__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BurnPresaleInterface {
    return new utils.Interface(_abi) as BurnPresaleInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BurnPresale {
    return new Contract(address, _abi, signerOrProvider) as BurnPresale;
  }
}
